import React from 'react'
import { Slider } from '../components/Slider'
import styles from "./css/TitlePage.module.css"

import block1 from "../images/titlepage/courses.webp"
import block2 from "../images/titlepage/zno.jpg"
import block3 from "../images/titlepage/repetytor.jpg"
import { Link } from 'react-router-dom'

export const TitlePage = () => {
  return (
    <div style={{ marginTop: "-40px" }}>
      <Slider />

      <div className={styles.blocks}>
        <div className={styles.block}>
          <Link to={"/catalog?35"}>
            <div className={styles.block__content} style={{ background: `url(${block1}) 50% 50%/cover no-repeat` }}>
              <h2 className={styles.h3}>Курси</h2>
            </div>
          </Link>
        </div>
        <div className={styles.block}>
          <Link to={"/catalog?40"}>
            <div className={styles.block__content} style={{ background: `url(${block2}) 50% 50%/cover no-repeat` }}>
              <h2 className={styles.h3}>Зно</h2>
            </div>
          </Link>
        </div>
        <div className={styles.block}>
          <Link to={"/catalog?37"}>
            <div className={styles.block__content} style={{ background: `url(${block3}) 50% 50%/cover no-repeat` }}>
              <h2 className={styles.h3}>Репетитори</h2>
            </div>
          </Link>
        </div>
      </div>
    </div>
  )
}
